import { ExtranetOrderStatusEnum, GetExtranetOrderQueryDto } from '@pharmac-extranet/extranet-api'
import { cleanQueryParams } from '../../../features/infinite-query/util/cleanQueryParams'

type TStatusType = ExtranetOrderStatusEnum

export const mapOrderSearchParamsToQueryParams = (
  searchParams: URLSearchParams
): GetExtranetOrderQueryDto => {
  const parsedParams = {
    search: searchParams.get('search') ?? undefined,
    vnr: searchParams.get('vnr') ?? undefined,
    sendingDate: searchParams.get('sendingDate') ?? undefined,
    startDate: searchParams.get('startDate') ?? undefined,
    endDate: searchParams.get('endDate') ?? undefined,
    startCreatedDateRange: searchParams.get('startCreatedDateRange') ?? undefined,
    endCreatedDateRange: searchParams.get('endCreatedDateRange') ?? undefined,
    startSendingDate: searchParams.get('startSendingDate') ?? undefined,
    endSendingDate: searchParams.get('endSendingDate') ?? undefined,
    hasChanges: searchParams.get('hasChanges') ?? undefined,
    status: (searchParams.getAll('status').length > 0
      ? searchParams.getAll('status')
      : undefined) as undefined | TStatusType,
  }

  return cleanQueryParams(parsedParams)
}
